"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var i=e(require("styled-components")).default.section`
  @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
    border-left: ${({hasVisualizer:e,theme:i})=>e?`1px solid ${i.colors.grey[300]}`:"none"};
  }

  .inner {
    display: flex;
    flex-direction: column;

    > header {
      display: none;

      @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        display: ${({hasVisualizer:e})=>e?"none":"grid"};
        grid-row-gap: 29px;
        padding: 35px 0 30px;
        width: 100%;
      }

      > nav {
        @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
          display: flex;
          flex-direction: row;
          justify-content: space-around;
        }

        > button {
          background: transparent;
          border: none;
          outline: none;
          font-weight: 700;
          position: relative;
          padding: 0 0 9px;
          cursor: pointer;

          &::after {
            content: '';
            display: block;
            width: 100%;
            max-width: 31px;
            height: 1px;
            background: transparent;
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            transition: all 0.2s ease-in-out;
          }

          &:hover,
          &:active,
          &:focus {
            &::after {
              background: ${({theme:e})=>e.colors.grey[500]};
            }
          }

          &.active {
            &::after {
              background: ${({theme:e})=>e.colors.primary.default};
            }
          }
        }
      }

      > .description {
        margin: 0;
        text-align: center;
      }
    }

    > ul {
      list-style: none;
      display: grid;
      grid-row-gap: 48px;
      padding: 30px ${({theme:e})=>e.spacing.large} 42px;
      margin: 0;
      width: 100%;
      box-sizing: border-box;

      @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        padding: ${({hasVisualizer:e})=>e?"51px 45px 42px":"30px 0 42px"};
        margin-bottom: auto;

        > li {
          ${({hasVisualizer:e})=>!e&&"\n              grid-row-start: 1;\n              grid-column-start: 1;\n            "}
        }
      }
    }

    > footer {
      padding: 0 ${({theme:e})=>e.spacing.large} 87px;
      width: 100%;
      box-sizing: border-box;

      @media (min-width: ${({theme:e})=>e.breakpoints.large}) {
        padding: 23px ${({hasVisualizer:e})=>e?"45px":"0"};
        position: sticky;
        bottom: 0;
      }

      .DXButton {
        width: 100%;
      }
    }
  }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
